import { render, staticRenderFns } from "./ConfirmRefund.vue?vue&type=template&id=2fa4369f&scoped=true&"
import script from "./ConfirmRefund.vue?vue&type=script&lang=js&"
export * from "./ConfirmRefund.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRefund.vue?vue&type=style&index=0&id=2fa4369f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4369f",
  null
  
)

export default component.exports